import React, { useContext, useEffect, useState } from 'react';
import { mapRecipeToCardData } from '../ProductCard/ProductCard.helper';
import { ProductCard } from '../ProductCard/ProductCard';
import { ProductCardSlider } from '../ProductCard/ProductCardsSlider';
import { emptyFavoritesRecipesCollection, getFavouriteRecipes } from '../../../../api/ECOM/​GetFavouriteRecipes.api';
import { isLoggedIn } from '../../../../data/user.model';
import { ProductContext } from '../../../pages/ProductStencil';
import { useI18N } from "../../../my-puratos/hoc/withI18N";

const getFavoriteRecipes = async () => {
    if (!isLoggedIn()) { return emptyFavoritesRecipesCollection; }
    const outSystemResponse = await getFavouriteRecipes();
    if (outSystemResponse?.TotalRecipes) {
        return outSystemResponse;
    }
    return emptyFavoritesRecipesCollection;
};

export const RelatedRecipes = () => {
    const productData = useContext(ProductContext);
    const [favoriteRecipes, setFavoriteRecipes] = useState(null);
    const translate = useI18N();

    useEffect(() => {
        const fetchFavoriteRecipes = async () => {
            const favoriteRecipesData = await getFavoriteRecipes();
            setFavoriteRecipes(favoriteRecipesData);
        };
        if (productData?.relatedRecipes) {
            fetchFavoriteRecipes();
        }
    }, []);

    if (!productData?.relatedRecipes) { return null; }

    const { recipes } = productData.relatedRecipes;
    const renditionFallback = productData.product.renditionFallback;
    if (!recipes.length) { return null; }
    const renderedProductCards = [...recipes].splice(0, 12).map((recipe, index) => (
        <ProductCard data={mapRecipeToCardData(recipe, favoriteRecipes, renditionFallback)} key={index} />
    ));

    return (
        <div className="pdp-section__container">
            <ProductCardSlider title={translate('Related recipes')}>
                {renderedProductCards}
            </ProductCardSlider>
        </div>
    );
};
